import { Placeholder as RawPlaceholder } from '@wearetla/tla-essentials-tools/partials/placeholder';
import classNames from 'classnames';
import '/assets/styles/partials/placeholder.scss';

const Placeholder = ({ dark, darker, primary, className, ...props }) => (
	<RawPlaceholder {...props} className={classNames(className, { dark, darker, primary })} />
);

export default Placeholder;
